import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";
import { ChangeOfAddress, ChangeOfAddressForm } from "./changeOfAddressDomain";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeOfAddress>,
  data?: ChangeOfAddress,
): ChangeOfAddressForm {
  return new ChangeOfAddressForm(context, data, dispatch);
}

export function handleEvent() {}

export function isValid(form: ChangeOfAddressForm): boolean {
  return form.isValid;
}

export function validate(form: ChangeOfAddressForm): boolean {
  return form.validate();
}

export function applyForm(form: ChangeOfAddressForm): ChangeOfAddress {
  return {
    type: DecisionType.changeOfAddress,
    options: form.changeOptions.selected,
    addressLine1: form.changesBusinessAddress
      ? form.addressLine1.validatedValue || undefined
      : undefined,
    addressLine2: form.changesBusinessAddress
      ? form.addressLine2.validatedValue || undefined
      : undefined,
    zip: form.changesBusinessAddress ? form.zip.validatedValue || undefined : undefined,
    city: form.changesBusinessAddress ? form.city.validatedValue || undefined : undefined,
    country: form.changesBusinessAddress ? form.country.validatedValue || undefined : undefined,
    mailingAddressLine1: form.changesMailingAddress
      ? form.mailingAddressLine1.validatedValue || undefined
      : undefined,
    mailingAddressLine2: form.changesMailingAddress
      ? form.mailingAddressLine2.validatedValue || undefined
      : undefined,
    mailingZip: form.changesMailingAddress
      ? form.mailingZip.validatedValue || undefined
      : undefined,
    mailingCity: form.changesMailingAddress
      ? form.mailingCity.validatedValue || undefined
      : undefined,
    mailingCountry: form.changesMailingAddress
      ? form.mailingCountry.validatedValue || undefined
      : undefined,
    previousAddress: form.previousAddress,
    previousMailingAddress: form.previousMailingAddress,
  };
}

export const changeOfAddressHandler: DecisionTypeHandler<
  DecisionType.changeOfAddress,
  ChangeOfAddress,
  ChangeOfAddressForm
> = {
  type: DecisionType.changeOfAddress,
  initNewForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
